<div class="parent">
<div style="margin: 100px;">
    <h1>Let's translate your message!</h1>
    <button class="custom-btn btn-2" style="margin: 10px;" (click)="startService()">Start Speaking</button>
    <button class="custom-btn btn-2" style="margin: 10px;" (click)="stopService()">Let's Translate</button>
    <p>{{service.text}}</p>
</div>

<div id="output" class="container">

</div>
</div>
